import HeroImage from './HeroImage';
import schema from './props-schema';

HeroImage.schema = schema;

// https://github.com/webpack/webpack/issues/706
export default HeroImage;
